<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <component :is="layout">
      <router-view />
    </component>

    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
//import { provideToast } from 'vue-toastification/composition'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import useAppConfig from '@core/app-config/useAppConfig'
import { useAppConfigStore } from '@/stores/appConfigStore'
import { useAppStore } from '@/stores/appStore'

import { useWindowSize, useCssVar } from '@vueuse/core'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,

    ScrollToTop,
  },
  beforeCreate() {
    //  Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')

  },
  setup() {
    const route = useRoute()
    const appConfigStore = useAppConfigStore()
    const appStore = useAppStore()
    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout
    const contentLayoutType = computed(() => appConfigStore.layout.type)
    const layout = computed(() => {
      if (route.meta.layout === 'full') return 'layout-full'
      return `layout-${contentLayoutType.value}`
    })

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    /*provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })*/

    // Set Window Width in store
    appStore.updateWindowWidth(window.innerWidth)
    const { width: windowWidth, height: windowHeight } = useWindowSize()
    const updateViewportHeight = val => {
      document.documentElement.style.setProperty('--vh', `${val * 0.01}px`)
    }

    updateViewportHeight(window.innerHeight)
    watch(windowWidth, val => {
      appStore.updateWindowWidth(val)
    })
    watch(windowHeight, val => {
      updateViewportHeight(val)
    })

    return {
      layout,
      skinClasses,
      enableScrollToTop,
    }
  },
}
</script>
